import { ArrowUpRight, Mail, Phone, Info } from "lucide-react";
import { useContent } from "@/content";
import { Section } from "@/components/Layout";
import { NotifyForm, ContactForm } from "@/components/Forms";
import { WinnerSeal } from "@/components/Brand";
import { Reveal, Eyebrow, MaskedTitle, GoldLine } from "@/components/Motion";

export const FinalCall = ({ pageMode = false }) => {
  const c = useContent();
  const f = c.finalCall;
  const team = f.team;
  const rows = [["email", Mail], ["phone", Phone], ["other", Info]].filter(([k]) => team[k]);
  return (
    <Section id={f.id} tone="aubergine" className="pb-24 pt-24 md:pb-32 md:pt-32">
      <div className="grid gap-16 lg:grid-cols-[1fr_1fr] lg:gap-28">
        <div>
          {pageMode ? (
            <>
              <Reveal><Eyebrow>{c.contactPage.eyebrow}</Eyebrow></Reveal>
              <MaskedTitle as="h1" className="mt-6 font-serif text-[2rem] leading-[1.08] md:text-[3rem]" data-testid="contact-page-title">{c.contactPage.title}</MaskedTitle>
            </>
          ) : (
            <>
              <Reveal><WinnerSeal size={110} /></Reveal>
              <MaskedTitle className="mt-10 font-serif text-2xl leading-[1.1] md:text-[1.75rem]" data-testid="final-call-title">{f.title}</MaskedTitle>
              <Reveal delay={0.1}><p className="mt-4 font-serif text-xl italic text-copper">{f.tagline}</p></Reveal>
            </>
          )}
          <GoldLine className="my-10 max-w-[140px]" />
          <Reveal>
            <p className="text-[0.75rem] uppercase tracking-[0.3em] text-copper">{f.keyDatesTitle}</p>
            <dl className="mt-5 space-y-4" data-testid="final-key-dates">
              {f.keyDates.map((d) => (
                <div key={d.label} className="flex flex-wrap items-baseline justify-between gap-x-6 border-b border-copper/20 pb-4">
                  <dt className="text-sm text-white/85">{d.label}</dt>
                  <dd className="font-serif text-xl">{d.value}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
          <Reveal delay={0.1} className="mt-8">
            <p className="text-sm text-white/85">{f.applyOn}</p>
            <a href={c.site.applyUrl} target="_blank" rel="noopener noreferrer" data-testid="final-apply-link" className="link-line mt-2 inline-flex items-center gap-2 font-serif text-2xl text-copper">
              <span className="ltr">{c.site.applyDomain}</span> <ArrowUpRight size={18} strokeWidth={1.2} />
            </a>
          </Reveal>
          <Reveal delay={0.15} className="mt-10">
            <p className="text-[0.75rem] uppercase tracking-[0.3em] text-copper">{f.teamTitle}</p>
            <ul className="mt-4 space-y-3 text-sm" data-testid="team-contacts">
              {rows.length === 0 && <li className="text-white/85" data-testid="team-pending">{f.teamPending}</li>}
              {rows.map(([k, Icon]) => (
                <li key={k} className="flex items-center gap-3 text-white/80"><Icon size={16} strokeWidth={1} className="text-copper" />{f.teamLabels[k]} : <span className="ltr">{team[k]}</span></li>
              ))}
            </ul>
          </Reveal>
        </div>
        <div className="space-y-16">
          {!pageMode && (
            <Reveal>
              <h3 className="mb-7 font-serif text-2xl">{c.forms.notify.title}</h3>
              <NotifyForm />
            </Reveal>
          )}
          <Reveal id="contact-form-anchor">
            <h3 className="mb-7 font-serif text-2xl">{c.forms.contact.title}</h3>
            <ContactForm />
          </Reveal>
        </div>
      </div>
    </Section>
  );
};
